<script>
	const assignmentService = require('services/assignmentService');
	const pubsub = require('events/pubsub');
	const uaParser = new (require('ua-parser-js'))();
	const { assetUrl } = require('utilities/urlUtilities');
	const stringUtilities = require('utilities/stringUtilities');

	module.exports = {
		props: ['student', 'assessment', 'question-info'],

		components: {
			'validated-textarea': require('components/validated-textarea.vue').default
		},

		data() {
			return {
				note: null
			};
		},

		computed: {
			noteImageSrc() {
				const imageSrc = `/assets/dist/images/icon-note${this.note ? '-active' : ''}.svg`;

				return assetUrl(imageSrc);
			},
			studentName() {
				return stringUtilities.stripHTML(this.student.firstName);
			}
		},

		methods: {
			openPopup() {
				this.$refs.popup.show(this.$refs.noteButton, 'Note');
			},

			save(event) {
				let field = event && event.target ? event.target : null;
				this.note = field ? field.value : null;
				if (typeof this.note !== 'undefined') {
					assignmentService
						.giveAnswerFeedback({
							f: this.note,
							aid: this.questionInfo.assignmentId,
							uid: this.student.uid,
							qsid: this.questionInfo.qsid,
							qid: this.questionInfo.qid
						})
						.then(() => {
							var q = this.assessment.students[this.student.uid].answers[this.questionInfo.qsid];

							for (var i = 0, l = q.length; i < l; i++) {
								if (q[i].qid === this.questionInfo.qid) {
									q[i].teacherNote = this.note;
								}
							}
						});
				}
			},

			getNote() {
				var q = this.assessment.students[this.student.uid].answers[this.questionInfo.qsid];

				if (q) {
					for (var i = 0, l = q.length; i < l; i++) {
						if (q[i].qid === this.questionInfo.qid) {
							return q[i].teacherNote;
						}
					}
				}

				return null;
			}
		},

		mounted() {
			this.own(
				pubsub.subscribe('open-note', options => {
					if (options.uid === this.student.uid && options.qid == this.questionInfo.qid) {
						this.openPopup();
					}
				})
			);

			this.note = this.getNote();
		},

		beforeDestroy() {
			// In Safari, if the user enters some text into the textarea, and then directly clicks
			// the browser back button, the "change" event on textarea does not fire.
			if (uaParser.getBrowser().name === 'Safari' && this.note !== this.getNote()) {
				this.save();
			}
		}
	};
</script>
<style lang="scss">
	.answer-note {
		display: inline-block;

		img.open-popup {
			cursor: pointer;
		}

		.popup-wrapper .popup .validated-textarea {
			height: 100%;

			textarea,
			.placeholder {
				padding: 0;
				margin-bottom: 0;
				border: 0px;
				resize: none;
			}
		}
	}
</style>
<template>
	<div class="answer-note">
		<button
			class="button -link"
			v-on:click="openPopup"
			ref="noteButton"
			aria-label="Add note"
			aria-haspopup="dialog">
			<img
				class="open-popup"
				:src="noteImageSrc" />
		</button>
		<popup
			ref="popup"
			class="note"
			:height="'5rem'">
			<validated-textarea
				slot="content"
				@change.native="save"
				:value="note"
				:placeholder="studentName ? 'Add a note to ' + studentName + '...' : 'Add a note...'"
				:hide-message-bar="true"></validated-textarea>
		</popup>
	</div>
</template>
